import { Component, OnInit,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-listedproducts',
  templateUrl: './listedproducts.component.html',
  styleUrls: ['./listedproducts.component.css']
})
export class ListedproductsComponent implements OnInit {

  pageName = "Shop Products";
  modelData: any;
  modelName = 'Product';
  modelId = '0';

  displayedColumns: string[] = ['productName', 'productQuantity', 'status', 'category', 'view'];
  products = []
  dataSource = new MatTableDataSource<any>(this.products);

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private router: Router, private formBuilder: FormBuilder, private _data: CommonDataService) { 

    
    let context_id = sessionStorage.getItem('context')

    if(context_id != undefined) {

      this.getSellerProducts(context_id)
    }

  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;

  }

  getSellerProducts(context_id) {

    let modelObject1 = new FormData();
    modelObject1.append('modelName', this.modelName);
    // modelObject1.append('objectName', 'businessDetails');
    // modelObject1.append('id', this.modelId);
    modelObject1.append('context_id', context_id);

    $('#loader').show();
    //lets get the model for this page
        this._data.getModelData(modelObject1) 
        .pipe(first())
        .subscribe(
          data => {
            console.log(data);
            this.modelData = data['covers'];
            this.products = this.getValidProducts()
            this.dataSource = new MatTableDataSource<any>(this.products);
            this.dataSource.paginator = this.paginator;


          },
          error => {

            console.log(error);
            iziToast.success({
              title: 'Error!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Failed to retrieve products info.'
          });

          $('#loader').hide();

          },

          () => {
              $('#loader').hide();
          }
      );
  }

  getValidProducts() {
    return this.modelData
    // return this.modelData.filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['ProductFlags']['published'] === false);
  }

  createProduct(id)
  {
    this.queryParamsSet({mid: id});
  	this.router.navigate(['/sellers/account/create-product']);
  }

  queryParamsSet(dataParams: any) {
    this._data.queryParamsChanged.next(dataParams);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getProductStockQuantity(id) {
    return 15
  }

}
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 545343424, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 244232323, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 232423133, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  {position: 432423423, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  {position: 544234431, name: 'Boron', weight: 10.811, symbol: 'B'},
  {position: 623452413, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  {position: 732342312, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  {position: 812432312, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  {position: 912343123, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  {position: 101342311, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
  {position: 113234131, name: 'Sodium', weight: 22.9897, symbol: 'Na'},
  {position: 122344233, name: 'Magnesium', weight: 24.305, symbol: 'Mg'},
  {position: 132342332, name: 'Aluminum', weight: 26.9815, symbol: 'Al'},
  {position: 142323323, name: 'Silicon', weight: 28.0855, symbol: 'Si'},
  {position: 15, name: 'Phosphorus', weight: 30.9738, symbol: 'P'},
  {position: 16, name: 'Sulfur', weight: 32.065, symbol: 'S'},
  {position: 17, name: 'Chlorine', weight: 35.453, symbol: 'Cl'},
  {position: 18, name: 'Argon', weight: 39.948, symbol: 'Ar'},
  {position: 19, name: 'Potassium', weight: 39.0983, symbol: 'K'},
  {position: 20, name: 'Calcium', weight: 40.078, symbol: 'Ca'},
];
